import { TrendingDown, TrendingUp } from 'lucide-react';
import type { ReactNode } from 'react';
import { percentagem } from '../formatos';

export function Kpi({ rotulo, valor, sub, variacao, inverterCor }: {
  rotulo: string;
  valor: ReactNode;
  sub?: string;
  /** Percentage change against the previous period; null when there is none. */
  variacao?: number | null;
  /** For measures where up is bad (cost), so the colour matches the meaning. */
  inverterCor?: boolean;
}) {
  const subiu = (variacao ?? 0) > 0;
  const bom = inverterCor ? !subiu : subiu;

  return (
    <div className="cartao p-4">
      <p className="text-[11px] font-medium uppercase tracking-wide text-tinta-500 dark:text-tinta-400">
        {rotulo}
      </p>
      <p className="mt-1.5 text-2xl font-semibold tabular-nums text-tinta-900 dark:text-papel-50">
        {valor}
      </p>
      <div className="mt-1 flex items-center gap-2 text-xs">
        {sub && <span className="text-tinta-500 dark:text-tinta-400">{sub}</span>}
        {variacao !== null && variacao !== undefined && (
          <span
            className={`flex items-center gap-0.5 font-medium ${
              bom
                ? 'text-emerald-600 dark:text-emerald-400'
                : 'text-red-600 dark:text-red-400'
            }`}
          >
            {subiu
              ? <TrendingUp className="h-3 w-3" aria-hidden />
              : <TrendingDown className="h-3 w-3" aria-hidden />}
            {percentagem(variacao)}
          </span>
        )}
      </div>
    </div>
  );
}

export function GrelhaKpi({ children }: { children: ReactNode }) {
  return <div className="grid grid-cols-2 gap-3 lg:grid-cols-3 xl:grid-cols-6">{children}</div>;
}
